import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";

export function PlaySymbolSoundCommand(symbolType: string, matches: string, currentCycle: string) {
    Services.sound.event(SoundEvent.symbol_ID_win, symbolType);
    Services.sound.event(SoundEvent.symbol_ID_win_CYCLE, symbolType, currentCycle);
    Services.sound.event(SoundEvent.symbol_ID_MATCHES_win, symbolType, matches);
    Services.sound.event(SoundEvent.symbol_ID_win_MATCHES_CYCLE, symbolType, matches, currentCycle);
    Services.sound.event(SoundEvent.symbol_any_win);
    Services.sound.event(SoundEvent.symbol_any_win_CYCLE, currentCycle);
    Services.sound.event(SoundEvent.symbol_any_MATCHES_win, matches);
    Services.sound.event(SoundEvent.symbol_any_win_MATCHES_CYCLE, matches, currentCycle);
}
